import { PartnerApiCustomerClient } from '@repo/lib-http-client-api-partner';

import { getStoredToken } from '@/shared/services/session.service';

const REQUEST_TIMEOUT_MS = 15_000;

export class MissingCustomerTokenError extends Error {
  public constructor() {
    super('Missing customer token');
    this.name = 'MissingCustomerTokenError';
  }
}

interface GetPartnerApiCustomerClientOptions {
  acceptLanguage?: string;
}

export function getPartnerApiCustomerClient({
  acceptLanguage,
}: GetPartnerApiCustomerClientOptions = {}): PartnerApiCustomerClient {
  const customerToken = getStoredToken();

  if (customerToken === null) {
    throw new MissingCustomerTokenError();
  }

  return new PartnerApiCustomerClient({
    baseUrl: import.meta.env.VITE_PARTNER_API_URL,
    customerToken,
    timeout: REQUEST_TIMEOUT_MS,
    ...(acceptLanguage === undefined ? {} : { headers: { 'Accept-Language': acceptLanguage } }),
  });
}
